import React, { useState } from 'react';
import { TextField, Button, Typography, Alert } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import LoginLayout from '../../commun/LoginLayout';
import './auth.css';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate   = useNavigate();
  const [form, setForm] = useState({ newPassword: '', confirmPassword: '' });
  const [message, setMessage] = useState({ type: '', text: '' });
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const handleChange = e =>
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    if (form.newPassword !== form.confirmPassword) {
      setMessage({ type: 'error', text: 'Les mots de passe ne correspondent pas.' });
      return;
    }
    try {
      await axios.post(`${API_BASE}/api/auth/reset-password`, {
        token, newPassword: form.newPassword,
      });
      setMessage({
        type: 'success',
        text: 'Mot de passe réinitialisé avec succès. Redirection...',
      });
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setMessage({
        type: 'error',
        text: err.response?.data?.message || 'Erreur lors de la réinitialisation.',
      });
    }
  };

  return (
    <LoginLayout>
      <Typography variant="h5" align="center" gutterBottom>
        Réinitialiser votre mot de passe
      </Typography>
      <Typography variant="body2" align="center" className="mb-2">
        Veuillez saisir votre nouveau mot de passe.
      </Typography>

      {message.text && (
        <Alert severity={message.type} className="mb-2">{message.text}</Alert>
      )}

      <form onSubmit={handleSubmit}>
        <TextField
          name="newPassword"
          label="Nouveau mot de passe"
          type="password"
          fullWidth
          required
          className="mb-2"
          value={form.newPassword}
          onChange={handleChange}
        />
        <TextField
          name="confirmPassword"
          label="Confirmer le mot de passe"
          type="password"
          fullWidth
          required
          className="mb-3"
          value={form.confirmPassword}
          onChange={handleChange}
        />
        <Button type="submit" variant="contained" fullWidth>
          Réinitialiser
        </Button>
      </form>
    </LoginLayout>
  );
};

export default ResetPassword;
